var React = require('react');

function CommunityHub (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12 6.5a2.333 2.333 0 1 1 0 4.667A2.333 2.333 0 0 1 12 6.5ZM7.333 8.167c.374 0 .72.1 1.02.28-.1.953.18 1.9.754 2.64a1.998 1.998 0 1 1-3.188-2.335 2 2 0 0 1 1.414-.585Zm9.334 0a2 2 0 1 1-1.774 2.92 3.69 3.69 0 0 0 .754-2.64c.3-.18.646-.28 1.02-.28Zm-9 6.833c0-1.38 1.94-2.5 4.333-2.5 2.393 0 4.333 1.12 4.333 2.5v1.167H7.667V15ZM4 16.167v-1c0-.927 1.26-1.707 2.967-1.934A2.696 2.696 0 0 0 6.333 15v1.167H4Zm16 0h-2.333V15c0-.687-.24-1.313-.634-1.767C18.74 13.46 20 14.24 20 15.167v1Z"}));
}

CommunityHub.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = CommunityHub;

CommunityHub.default = CommunityHub;
